<script lang="ts" setup>
  import { cn } from '@/lib/utils'
  import { ChevronDown } from 'lucide-vue-next'
  import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui'
  import { computed, type HTMLAttributes } from 'vue'
  import { selectTriggerClass } from '.'

  const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger :class="cn(selectTriggerClass, props.class)" v-bind="forwardedProps">
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="w-4 h-4 text-content-muted-foreground shrink-0" />
    </SelectIcon>
  </SelectTrigger>
</template>
